<template>
  <div class="pc_new">
    <header class="header" v-if="hederShow">
      <div class="inner2">
        <h1 @click="scrollTop()">
          <img
            src="~@/assets/images/pc_new/menu/logo.svg"
            class="logo_img"
            alt="ministock"
          />
        </h1>
        <ul class="menu">
          <li @click="goSlide(1)">
            <button type="button" class="btn_memu">
              <svg
                width="58"
                height="124"
                viewBox="0 0 58 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M5.94813 0.68H9.02813L14.4081 15H11.4281L10.2481 11.58H4.72813L3.54813 15H0.568125L5.94813 0.68ZM9.36813 9.1L8.08813 5.52L7.56813 3.78H7.40813L6.88813 5.52L5.60812 9.1H9.36813ZM15.7645 0.68H18.3845V4.98L18.2245 6.38H18.3845C18.6245 5.96667 18.9979 5.61333 19.5045 5.32C20.0112 5.02667 20.6379 4.88 21.3845 4.88C22.0112 4.88 22.6045 5.01333 23.1645 5.28C23.7379 5.53333 24.2379 5.89333 24.6645 6.36C25.1045 6.81333 25.4512 7.36 25.7045 8C25.9579 8.64 26.0845 9.34 26.0845 10.1C26.0845 10.86 25.9579 11.56 25.7045 12.2C25.4512 12.84 25.1045 13.3933 24.6645 13.86C24.2379 14.3133 23.7379 14.6733 23.1645 14.94C22.6045 15.1933 22.0112 15.32 21.3845 15.32C20.6379 15.32 20.0112 15.1733 19.5045 14.88C18.9979 14.5867 18.6245 14.2333 18.3845 13.82H18.2245V15H15.7645V0.68ZM20.8445 12.9C21.1912 12.9 21.5179 12.8333 21.8245 12.7C22.1445 12.5667 22.4245 12.38 22.6645 12.14C22.9045 11.9 23.0979 11.6067 23.2445 11.26C23.3912 10.9133 23.4645 10.5267 23.4645 10.1C23.4645 9.67333 23.3912 9.28667 23.2445 8.94C23.0979 8.59333 22.9045 8.3 22.6645 8.06C22.4245 7.82 22.1445 7.63333 21.8245 7.5C21.5179 7.36667 21.1912 7.3 20.8445 7.3C20.4979 7.3 20.1645 7.36667 19.8445 7.5C19.5379 7.62 19.2645 7.8 19.0245 8.04C18.7845 8.28 18.5912 8.57333 18.4445 8.92C18.2979 9.26667 18.2245 9.66 18.2245 10.1C18.2245 10.54 18.2979 10.9333 18.4445 11.28C18.5912 11.6267 18.7845 11.92 19.0245 12.16C19.2645 12.4 19.5379 12.5867 19.8445 12.72C20.1645 12.84 20.4979 12.9 20.8445 12.9ZM32.3967 4.88C33.1567 4.88 33.8501 5.01333 34.4767 5.28C35.1167 5.53333 35.6634 5.89333 36.1167 6.36C36.5834 6.81333 36.9434 7.36 37.1967 8C37.4634 8.64 37.5967 9.34 37.5967 10.1C37.5967 10.86 37.4634 11.56 37.1967 12.2C36.9434 12.84 36.5834 13.3933 36.1167 13.86C35.6634 14.3133 35.1167 14.6733 34.4767 14.94C33.8501 15.1933 33.1567 15.32 32.3967 15.32C31.6367 15.32 30.9367 15.1933 30.2967 14.94C29.6701 14.6733 29.1234 14.3133 28.6567 13.86C28.2034 13.3933 27.8434 12.84 27.5767 12.2C27.3234 11.56 27.1967 10.86 27.1967 10.1C27.1967 9.34 27.3234 8.64 27.5767 8C27.8434 7.36 28.2034 6.81333 28.6567 6.36C29.1234 5.89333 29.6701 5.53333 30.2967 5.28C30.9367 5.01333 31.6367 4.88 32.3967 4.88ZM32.3967 12.9C32.7301 12.9 33.0501 12.84 33.3567 12.72C33.6767 12.5867 33.9567 12.4 34.1967 12.16C34.4367 11.92 34.6234 11.6267 34.7567 11.28C34.9034 10.9333 34.9767 10.54 34.9767 10.1C34.9767 9.66 34.9034 9.26667 34.7567 8.92C34.6234 8.57333 34.4367 8.28 34.1967 8.04C33.9567 7.8 33.6767 7.62 33.3567 7.5C33.0501 7.36667 32.7301 7.3 32.3967 7.3C32.0501 7.3 31.7234 7.36667 31.4167 7.5C31.1101 7.62 30.8367 7.8 30.5967 8.04C30.3567 8.28 30.1634 8.57333 30.0167 8.92C29.8834 9.26667 29.8167 9.66 29.8167 10.1C29.8167 10.54 29.8834 10.9333 30.0167 11.28C30.1634 11.6267 30.3567 11.92 30.5967 12.16C30.8367 12.4 31.1101 12.5867 31.4167 12.72C31.7234 12.84 32.0501 12.9 32.3967 12.9ZM45.9625 13.72H45.8025C45.4958 14.2133 45.0825 14.6067 44.5625 14.9C44.0425 15.18 43.4492 15.32 42.7825 15.32C41.5425 15.32 40.6158 14.94 40.0025 14.18C39.4025 13.42 39.1025 12.4067 39.1025 11.14V5.2H41.7225V10.82C41.7225 11.5267 41.8758 12.0533 42.1825 12.4C42.5025 12.7333 42.9625 12.9 43.5625 12.9C43.9225 12.9 44.2358 12.8267 44.5025 12.68C44.7825 12.52 45.0158 12.3133 45.2025 12.06C45.4025 11.7933 45.5492 11.4867 45.6425 11.14C45.7492 10.78 45.8025 10.4 45.8025 10V5.2H48.4225V15H45.9625V13.72ZM51.8445 7.44H50.1245V5.2H51.8445V2.2H54.4645V5.2H56.8645V7.44H54.4645V11.24C54.4645 11.4667 54.4845 11.68 54.5245 11.88C54.5779 12.0667 54.6712 12.2267 54.8045 12.36C54.9912 12.5733 55.2579 12.68 55.6045 12.68C55.8312 12.68 56.0112 12.66 56.1445 12.62C56.2779 12.5667 56.4045 12.5 56.5245 12.42L57.2645 14.72C56.9579 14.8667 56.6245 14.9733 56.2645 15.04C55.9179 15.12 55.5312 15.16 55.1045 15.16C54.6112 15.16 54.1645 15.0867 53.7645 14.94C53.3779 14.78 53.0512 14.5667 52.7845 14.3C52.1579 13.7 51.8445 12.8467 51.8445 11.74V7.44Z"
                  fill="#0D0D0D"
                />
              </svg>
              <span class="blind">About</span>
            </button>
          </li>
          <li @click="goSlide(2)">
            <button type="button" class="btn_memu">
              <svg
                width="72"
                height="124"
                viewBox="0 0 72 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M13.3174 12.7C12.6108 13.5533 11.7774 14.2067 10.8174 14.66C9.85742 15.1 8.78409 15.32 7.59742 15.32C6.53076 15.32 5.53742 15.1267 4.61742 14.74C3.71076 14.3533 2.92409 13.8267 2.25742 13.16C1.59076 12.4933 1.06409 11.7067 0.677422 10.8C0.290755 9.88 0.0974219 8.89333 0.0974219 7.84C0.0974219 6.78667 0.290755 5.80667 0.677422 4.9C1.06409 3.98 1.59076 3.18667 2.25742 2.52C2.92409 1.85333 3.71076 1.32667 4.61742 0.94C5.53742 0.553333 6.53076 0.359999 7.59742 0.359999C8.74409 0.359999 9.75076 0.559999 10.6174 0.96C11.4974 1.36 12.2774 1.94 12.9574 2.7L11.0574 4.54C10.6308 4.04667 10.1374 3.65333 9.57742 3.36C9.03076 3.06667 8.37742 2.92 7.61742 2.92C6.95076 2.92 6.32409 3.04 5.73742 3.28C5.15076 3.50667 4.63742 3.83333 4.19742 4.26C3.77076 4.68667 3.43076 5.20667 3.17742 5.82C2.92409 6.42 2.79742 7.09333 2.79742 7.84C2.79742 8.58667 2.92409 9.26667 3.17742 9.88C3.43076 10.48 3.77076 10.9933 4.19742 11.42C4.63742 11.8467 5.15076 12.18 5.73742 12.42C6.32409 12.6467 6.95076 12.76 7.61742 12.76C8.41742 12.76 9.12409 12.6 9.73742 12.28C10.3641 11.9467 10.9174 11.48 11.3974 10.88L13.3174 12.7ZM20.8143 13.96H20.6543C20.3476 14.3333 19.9743 14.6533 19.5343 14.92C19.1076 15.1867 18.5543 15.32 17.8743 15.32C17.3676 15.32 16.8876 15.2333 16.4343 15.06C15.9943 14.9 15.6076 14.6733 15.2743 14.38C14.941 14.0867 14.681 13.7333 14.4943 13.32C14.3076 12.9067 14.2143 12.4533 14.2143 11.96C14.2143 11.4533 14.3143 11 14.5143 10.6C14.7143 10.1867 14.9943 9.83333 15.3543 9.54C15.7143 9.24667 16.1343 9.02667 16.6143 8.88C17.1076 8.72 17.641 8.64 18.2143 8.64C18.8543 8.64 19.381 8.69333 19.7943 8.8C20.2076 8.89333 20.5476 8.99333 20.8143 9.1V8.8C20.8143 8.28 20.6076 7.85333 20.1943 7.52C19.781 7.17333 19.2676 7 18.6543 7C17.7476 7 16.981 7.38 16.3543 8.14L14.4543 6.84C15.4943 5.53333 16.9143 4.88 18.7143 4.88C20.2343 4.88 21.3943 5.24 22.1943 5.96C22.9943 6.66667 23.3943 7.72 23.3943 9.12V15H20.8143V13.96ZM20.8143 11.02C20.5076 10.8733 20.1876 10.76 19.8543 10.68C19.5343 10.5867 19.181 10.54 18.7943 10.54C18.1676 10.54 17.681 10.68 17.3343 10.96C17.001 11.2267 16.8343 11.56 16.8343 11.96C16.8343 12.36 16.9943 12.68 17.3143 12.92C17.6476 13.16 18.0276 13.28 18.4543 13.28C18.801 13.28 19.121 13.22 19.4143 13.1C19.7076 12.9667 19.9543 12.8 20.1543 12.6C20.3676 12.3867 20.5276 12.1467 20.6343 11.88C20.7543 11.6 20.8143 11.3133 20.8143 11.02ZM25.4774 5.2H27.9374V6.56H28.0974C28.2174 6.32 28.3774 6.1 28.5774 5.9C28.7774 5.7 28.9974 5.52667 29.2374 5.38C29.4908 5.23333 29.7574 5.12 30.0374 5.04C30.3308 4.96 30.6174 4.92 30.8974 4.92C31.2441 4.92 31.5374 4.95333 31.7774 5.02C32.0308 5.08667 32.2441 5.17333 32.4174 5.28L31.7174 7.66C31.5574 7.58 31.3774 7.52 31.1774 7.48C30.9908 7.42667 30.7574 7.4 30.4774 7.4C30.1174 7.4 29.7908 7.47333 29.4974 7.62C29.2041 7.75333 28.9508 7.94667 28.7374 8.2C28.5374 8.45333 28.3774 8.75333 28.2574 9.1C28.1508 9.43333 28.0974 9.8 28.0974 10.2V15H25.4774V5.2ZM42.2965 12.64C41.8432 13.44 41.2298 14.0867 40.4565 14.58C39.6965 15.0733 38.7632 15.32 37.6565 15.32C36.9098 15.32 36.2165 15.1933 35.5765 14.94C34.9498 14.6733 34.4032 14.3067 33.9365 13.84C33.4698 13.3733 33.1032 12.8267 32.8365 12.2C32.5832 11.56 32.4565 10.86 32.4565 10.1C32.4565 9.39333 32.5832 8.72667 32.8365 8.1C33.0898 7.46 33.4432 6.90667 33.8965 6.44C34.3498 5.96 34.8832 5.58 35.4965 5.3C36.1232 5.02 36.8098 4.88 37.5565 4.88C38.3432 4.88 39.0432 5.01333 39.6565 5.28C40.2698 5.53333 40.7832 5.89333 41.1965 6.36C41.6098 6.81333 41.9232 7.35333 42.1365 7.98C42.3498 8.60667 42.4565 9.28667 42.4565 10.02C42.4565 10.1133 42.4565 10.1933 42.4565 10.26C42.4432 10.34 42.4365 10.4133 42.4365 10.48C42.4232 10.5467 42.4165 10.62 42.4165 10.7H35.0365C35.0898 11.1 35.1965 11.4467 35.3565 11.74C35.5298 12.02 35.7365 12.26 35.9765 12.46C36.2298 12.6467 36.5032 12.7867 36.7965 12.88C37.0898 12.96 37.3898 13 37.6965 13C38.2965 13 38.7898 12.8667 39.1765 12.6C39.5765 12.32 39.8898 11.9733 40.1165 11.56L42.2965 12.64ZM39.9165 8.84C39.9032 8.66667 39.8432 8.47333 39.7365 8.26C39.6432 8.04667 39.4965 7.84667 39.2965 7.66C39.1098 7.47333 38.8698 7.32 38.5765 7.2C38.2965 7.08 37.9565 7.02 37.5565 7.02C36.9965 7.02 36.5032 7.18 36.0765 7.5C35.6498 7.82 35.3498 8.26667 35.1765 8.84H39.9165ZM53.5074 12.64C53.0541 13.44 52.4408 14.0867 51.6674 14.58C50.9074 15.0733 49.9741 15.32 48.8674 15.32C48.1208 15.32 47.4274 15.1933 46.7874 14.94C46.1608 14.6733 45.6141 14.3067 45.1474 13.84C44.6808 13.3733 44.3141 12.8267 44.0474 12.2C43.7941 11.56 43.6674 10.86 43.6674 10.1C43.6674 9.39333 43.7941 8.72667 44.0474 8.1C44.3008 7.46 44.6541 6.90667 45.1074 6.44C45.5608 5.96 46.0941 5.58 46.7074 5.3C47.3341 5.02 48.0208 4.88 48.7674 4.88C49.5541 4.88 50.2541 5.01333 50.8674 5.28C51.4808 5.53333 51.9941 5.89333 52.4074 6.36C52.8208 6.81333 53.1341 7.35333 53.3474 7.98C53.5608 8.60667 53.6674 9.28667 53.6674 10.02C53.6674 10.1133 53.6674 10.1933 53.6674 10.26C53.6541 10.34 53.6474 10.4133 53.6474 10.48C53.6341 10.5467 53.6274 10.62 53.6274 10.7H46.2474C46.3008 11.1 46.4074 11.4467 46.5674 11.74C46.7408 12.02 46.9474 12.26 47.1874 12.46C47.4408 12.6467 47.7141 12.7867 48.0074 12.88C48.3008 12.96 48.6008 13 48.9074 13C49.5074 13 50.0008 12.8667 50.3874 12.6C50.7874 12.32 51.1008 11.9733 51.3274 11.56L53.5074 12.64ZM51.1274 8.84C51.1141 8.66667 51.0541 8.47333 50.9474 8.26C50.8541 8.04667 50.7074 7.84667 50.5074 7.66C50.3208 7.47333 50.0808 7.32 49.7874 7.2C49.5074 7.08 49.1674 7.02 48.7674 7.02C48.2074 7.02 47.7141 7.18 47.2874 7.5C46.8608 7.82 46.5608 8.26667 46.3874 8.84H51.1274ZM55.3407 5.2H57.8007V6.56H57.9607C58.0807 6.32 58.2407 6.1 58.4407 5.9C58.6407 5.7 58.8607 5.52667 59.1007 5.38C59.354 5.23333 59.6207 5.12 59.9007 5.04C60.194 4.96 60.4807 4.92 60.7607 4.92C61.1074 4.92 61.4007 4.95333 61.6407 5.02C61.894 5.08667 62.1074 5.17333 62.2807 5.28L61.5807 7.66C61.4207 7.58 61.2407 7.52 61.0407 7.48C60.854 7.42667 60.6207 7.4 60.3407 7.4C59.9807 7.4 59.654 7.47333 59.3607 7.62C59.0674 7.75333 58.814 7.94667 58.6007 8.2C58.4007 8.45333 58.2407 8.75333 58.1207 9.1C58.014 9.43333 57.9607 9.8 57.9607 10.2V15H55.3407V5.2ZM66.9746 15.32C66.3346 15.32 65.7613 15.24 65.2546 15.08C64.7613 14.92 64.3279 14.7133 63.9546 14.46C63.5946 14.1933 63.2879 13.8933 63.0346 13.56C62.7813 13.2133 62.5879 12.8667 62.4546 12.52L64.7946 11.52C65.0213 12.0267 65.3213 12.4067 65.6946 12.66C66.0813 12.9 66.5079 13.02 66.9746 13.02C67.4546 13.02 67.8346 12.9333 68.1146 12.76C68.3946 12.5867 68.5346 12.38 68.5346 12.14C68.5346 11.8733 68.4146 11.66 68.1746 11.5C67.9479 11.3267 67.5479 11.1733 66.9746 11.04L65.5946 10.74C65.2879 10.6733 64.9679 10.5667 64.6346 10.42C64.3146 10.2733 64.0213 10.0867 63.7546 9.86C63.4879 9.63333 63.2679 9.36 63.0946 9.04C62.9213 8.72 62.8346 8.34667 62.8346 7.92C62.8346 7.44 62.9346 7.01333 63.1346 6.64C63.3479 6.26667 63.6346 5.95333 63.9946 5.7C64.3546 5.43333 64.7746 5.23333 65.2546 5.1C65.7479 4.95333 66.2746 4.88 66.8346 4.88C67.7679 4.88 68.6013 5.06667 69.3346 5.44C70.0679 5.8 70.6079 6.38 70.9546 7.18L68.6946 8.1C68.5079 7.71333 68.2346 7.43333 67.8746 7.26C67.5146 7.08667 67.1546 7 66.7946 7C66.4213 7 66.0946 7.08 65.8146 7.24C65.5346 7.38667 65.3946 7.58 65.3946 7.82C65.3946 8.04667 65.5079 8.22667 65.7346 8.36C65.9746 8.49333 66.2946 8.61333 66.6946 8.72L68.1946 9.08C69.1946 9.32 69.9346 9.70667 70.4146 10.24C70.9079 10.76 71.1546 11.38 71.1546 12.1C71.1546 12.5267 71.0546 12.9333 70.8546 13.32C70.6546 13.7067 70.3679 14.0533 69.9946 14.36C69.6346 14.6533 69.1946 14.8867 68.6746 15.06C68.1679 15.2333 67.6013 15.32 66.9746 15.32Z"
                  fill="#0D0D0D"
                />
              </svg>
              <span class="blind">Careers</span>
            </button>
          </li>
          <li @click="goSlide(3)">
            <button type="button" class="btn_memu">
              <svg
                width="63"
                height="124"
                viewBox="0 0 63 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M11.5328 0.915999H13.9448V17.638H11.5328V0.915999ZM4.96281 2.086C7.48281 2.086 9.33681 4.39 9.33681 8.026C9.33681 11.698 7.48281 14.002 4.96281 14.002C2.44281 14.002 0.588813 11.698 0.588813 8.026C0.588813 4.39 2.44281 2.086 4.96281 2.086ZM4.96281 4.264C3.72081 4.264 2.87481 5.578 2.87481 8.026C2.87481 10.51 3.72081 11.842 4.96281 11.842C6.20481 11.842 7.03281 10.51 7.03281 8.026C7.03281 5.578 6.20481 4.264 4.96281 4.264ZM19.0454 6.514H21.4394V9.574H19.0454V6.514ZM24.9134 6.514H27.2894V9.574H24.9134V6.514ZM15.6614 8.836H30.7274V10.726H15.6614V8.836ZM23.1674 11.572C26.7674 11.572 28.9454 12.652 28.9454 14.578C28.9454 16.522 26.7674 17.602 23.1674 17.602C19.5494 17.602 17.3714 16.522 17.3714 14.578C17.3714 12.652 19.5494 11.572 23.1674 11.572ZM23.1674 13.372C20.9354 13.372 19.8014 13.75 19.8014 14.578C19.8014 15.424 20.9354 15.802 23.1674 15.802C25.3994 15.802 26.5334 15.424 26.5334 14.578C26.5334 13.75 25.3994 13.372 23.1674 13.372ZM23.2034 1.168C26.8754 1.168 29.2334 2.392 29.2334 4.39C29.2334 6.37 26.8754 7.558 23.2034 7.558C19.5134 7.558 17.1734 6.37 17.1734 4.39C17.1734 2.392 19.5134 1.168 23.2034 1.168ZM23.2034 3.004C20.9174 3.004 19.6394 3.454 19.6394 4.39C19.6394 5.308 20.9174 5.758 23.2034 5.758C25.4894 5.758 26.7674 5.308 26.7674 4.39C26.7674 3.454 25.4894 3.004 23.2034 3.004ZM43.604 3.094H46.484V5.056H43.604V3.094ZM43.604 6.712H46.484V8.674H43.604V6.712ZM41.948 0.934H44.342V10.762H41.948V0.934ZM33.218 11.446H44.342V17.602H41.948V13.354H33.218V11.446ZM35.864 1.834C38.438 1.834 40.4 3.544 40.4 5.92C40.4 8.296 38.438 9.988 35.864 9.988C33.29 9.988 31.328 8.296 31.328 5.92C31.328 3.544 33.29 1.834 35.864 1.834ZM35.864 3.868C34.604 3.868 33.668 4.606 33.668 5.92C33.668 7.234 34.604 7.99 35.864 7.99C37.124 7.99 38.06 7.234 38.06 5.92C38.06 4.606 37.124 3.868 35.864 3.868ZM47.5166 2.14H54.6446V4.066H47.5166V2.14ZM49.5686 6.028H51.9446V10.204H49.5686V6.028ZM53.7086 2.14H56.0666V3.184C56.0666 4.354 56.0666 6.01 55.6706 8.08L53.3486 7.828C53.7086 5.776 53.7086 4.336 53.7086 3.184V2.14ZM57.6866 0.934H60.0986V13.408H57.6866V0.934ZM59.1446 6.01H62.0786V7.972H59.1446V6.01ZM48.9746 15.406H60.6206V17.314H48.9746V15.406ZM48.9746 12.292H51.3686V16H48.9746V12.292ZM46.7606 11.176L46.5446 9.286C49.4246 9.286 53.4386 9.232 56.7866 8.764L56.9306 10.456C53.4926 11.104 49.6226 11.176 46.7606 11.176Z"
                  fill="#0D0D0D"
                />
              </svg>
              <span class="blind">이용약관</span>
            </button>
          </li>
          <li>
            <button type="button" class="btn_memu" @click="downClick()">
              <svg
                width="95"
                height="124"
                viewBox="0 0 95 26"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_670_47092)">
                  <path
                    d="M42.7588 3.916H45.1708V20.638H42.7588V3.916ZM44.6308 10.09H47.5828V12.052H44.6308V10.09ZM32.7508 14.644H34.1548C36.9628 14.644 39.1768 14.554 41.6248 14.122L41.8588 16.102C39.3388 16.552 37.0528 16.624 34.1548 16.624H32.7508V14.644ZM32.7508 5.464H40.5268V7.39H35.1268V15.598H32.7508V5.464ZM47.6614 12.034H62.7634V13.924H47.6614V12.034ZM54.1234 13.276H56.5534V16.786H54.1234V13.276ZM49.4254 18.388H61.1074V20.314H49.4254V18.388ZM49.4254 15.328H51.8374V18.874H49.4254V15.328ZM55.2034 4.24C58.7854 4.24 61.1974 5.59 61.1974 7.696C61.1974 9.82 58.7854 11.152 55.2034 11.152C51.6034 11.152 49.2094 9.82 49.2094 7.696C49.2094 5.59 51.6034 4.24 55.2034 4.24ZM55.2034 6.13C53.0974 6.13 51.7834 6.67 51.7834 7.696C51.7834 8.722 53.0974 9.244 55.2034 9.244C57.3094 9.244 58.6234 8.722 58.6234 7.696C58.6234 6.67 57.3094 6.13 55.2034 6.13ZM63.238 16.822H78.322V18.766H63.238V16.822ZM69.556 13.672H71.95V17.614H69.556V13.672ZM64.93 5.014H76.63V10.558H67.342V13.366H64.966V8.686H74.254V6.904H64.93V5.014ZM64.966 12.412H77.008V14.338H64.966V12.412ZM80.5426 11.62H92.2606V13.528H80.5426V11.62ZM78.7966 16.642H93.8806V18.604H78.7966V16.642ZM80.5426 5.302H92.1346V7.246H82.9186V12.412H80.5426V5.302Z"
                    fill="#0D0D0D"
                  />
                  <path
                    d="M25 16.1211V19.5436C25 19.7956 24.7637 19.9999 24.4722 19.9999H6.52778C6.2363 19.9999 6 19.7956 6 19.5436V16.1211"
                    stroke="#0D0D0D"
                    stroke-width="2"
                    stroke-linecap="square"
                  />
                  <path
                    d="M15.5 4V14.6667"
                    stroke="#0D0D0D"
                    stroke-width="2"
                    stroke-linecap="square"
                  />
                  <path
                    d="M20.4492 10.5859C20.4492 10.5859 15.4165 15.2986 15.4165 15.2986C15.4165 15.2986 13.5793 13.4425 10.5512 10.4132"
                    stroke="#0D0D0D"
                    stroke-width="2"
                    stroke-linecap="square"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_670_47092">
                    <rect width="95" height="26" fill="white" />
                  </clipPath>
                </defs>
              </svg>
              <span class="blind">다운로드</span>
            </button>
            <ul class="appdown" :class="{ open: downVisible }">
              <li>
                <a
                  href="https://apps.apple.com/app/id1517001633"
                  target="_blank"
                >
                  <button type="button" class="btn_ios">
                    <svg
                      width="26"
                      height="30"
                      viewBox="0 0 26 30"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M18.8678 0C19.0129 1.68014 18.4048 3.34221 17.168 4.63694C15.9656 5.93468 14.1483 6.68441 12.2377 6.66635C12.1133 5.0374 12.7421 3.43254 13.979 2.20405C15.2332 0.960508 16.9779 0.171627 18.8678 0ZM24.7412 9.74069C22.658 10.996 21.3759 13.2087 21.3432 15.604C21.3465 18.3131 23.0046 20.7596 25.5556 21.8132C25.065 23.3727 24.3259 24.8457 23.3644 26.181C22.0758 28.0704 20.7219 29.918 18.5765 29.9501C17.5547 29.9736 16.8646 29.6861 16.1457 29.3866C15.3965 29.0744 14.616 28.7492 13.3961 28.7492C12.1 28.7492 11.2846 29.0854 10.4983 29.4095C9.81836 29.6897 9.16027 29.961 8.2321 29.9981C6.18809 30.0718 4.62482 27.9839 3.28722 26.1106C0.615279 22.2871 -1.46471 15.3382 1.32496 10.6085C2.6364 8.30609 5.08595 6.84266 7.77751 6.7562C8.93539 6.73262 10.0471 7.17041 11.0223 7.55444C11.7686 7.84834 12.4349 8.11075 12.9808 8.11075C13.4609 8.11075 14.1082 7.8591 14.8625 7.5659C16.0502 7.10416 17.5031 6.53938 18.9853 6.69215C21.2876 6.7626 23.42 7.893 24.7412 9.74069Z"
                        fill="#00B7CF"
                      />
                    </svg>
                    <span class="blind">앱스토어</span>
                  </button>
                </a>
              </li>
              <li>
                <a
                  href="https://play.google.com/store/apps/details?id=com.truefriend.ministock"
                  target="_blank"
                >
                  <button type="button" class="btn_and">
                    <svg
                      width="27"
                      height="30"
                      viewBox="0 0 27 30"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M14.3959 14.9984L0.258691 0.888672C0.0963212 1.21616 0 1.61796 0 2.10507V27.8971C0 28.3898 0.0990733 28.7998 0.266947 29.1273L14.3959 14.9984Z"
                        fill="#00B7CF"
                      />
                      <path
                        d="M0.300422 0.797979C0.305926 0.784219 0.314182 0.773211 0.322438 0.759451C0.314182 0.773211 0.308678 0.786971 0.300422 0.797979Z"
                        fill="#00B7CF"
                      />
                      <path
                        d="M15.213 14.1812L19.5667 9.82752L2.96647 0.396293C2.49587 0.126594 2.05279 0 1.6565 0C1.4556 0 1.27121 0.0357765 1.10059 0.0990733L15.213 14.1812Z"
                        fill="#00B7CF"
                      />
                      <path
                        d="M25.707 13.3172L20.6184 10.4248L16.0391 15.0042L20.6184 19.5726L25.707 16.6802C27.3362 15.7582 27.3362 14.2419 25.707 13.3172Z"
                        fill="#00B7CF"
                      />
                      <path
                        d="M15.2247 15.8242L1.14258 29.9119C1.6462 30.0825 2.27642 30 2.96718 29.6092L19.5785 20.1669L15.2247 15.8242Z"
                        fill="#00B7CF"
                      />
                      <path
                        d="M0.286487 29.1714C0.352536 29.2925 0.426841 29.4026 0.512154 29.4961C0.426841 29.3971 0.347032 29.2925 0.286487 29.1714Z"
                        fill="#00B7CF"
                      />
                    </svg>
                    <span class="blind">플레이스토어</span>
                  </button>
                </a>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </header>

    <div
      id="ministockContent2"
      class="ministock_container"
      @click="downVisible = false"
    >
      <!-- 메인 탑 -->
      <section class="section_main">
        <div class="inner">
          <h2>
            <img
              src="~@/assets/images/pc_new/img_main_tit.png"
              class="main_tit"
              alt="매일이 즐거운 투자루틴"
            />
          </h2>
          <img
            src="~@/assets/images/pc_new/img_main_txt01.svg"
            class="main_txt01"
            alt="초보자부터 숙련된 투자자까지 안전하고 편리한 최고의 투자 환경을 경험해보세요. "
          />
          <img
            src="~@/assets/images/pc_new/img_main_txt02.svg"
            class="main_txt02"
            alt="미니스탁은 투자에 대한 귀중한 경험을 쉽게 쌓아갈 수 있도록 도와드립니다."
          />
        </div>
      </section>

      <!-- 슬라이드 소개 -->
      <section class="section_slide">
        <div
          id="bgSlide"
          :class="{
            show01: slideShow === '01',
            show02: slideShow === '02',
            show03: slideShow === '03',
            show04: slideShow === '04',
            show05: slideShow === '05',
            second: secondShow,
          }"
        >
          <!-- 화면 높이에  따라서 show01 show02 show03 show04 show05가 바껴야 함 -->
          <h2>
            <div class="slider-pagination">
              <span class="slider-pagination-bullet"></span>
              <span class="slider-pagination-bullet"></span>
              <span class="slider-pagination-bullet"></span>
              <span class="slider-pagination-bullet"></span>
              <span class="slider-pagination-bullet"></span>
            </div>
            <img
              src="~@/assets/images/pc_new/img_slide_tit.svg"
              class="slide_tit"
              alt="smile season3"
            />
          </h2>
          <div class="items item01">
            <div class="slide_txtarea">
              <p class="slide_txt01">한국주식까지</p>
              <p class="slide_txt02">
                실시간으로 쉽게 투자해 보세요.
              </p>
            </div>
            <div class="anim_cont">
              <div class="play"><span class="img_stocks"></span></div>
            </div>
            <div class="slide_imgarea">
              <img
                src="~@/assets/images/pc_new/slide/img0102.png"
                class="slide_img02"
              />
              <img
                src="~@/assets/images/pc_new/slide/img0103.png"
                class="slide_img03"
              />
              <img
                src="~@/assets/images/pc_new/slide/img0104.png"
                class="slide_img04"
              />
              <img
                src="~@/assets/images/pc_new/slide/img0105.png"
                class="slide_img05"
              />
              <img
                src="~@/assets/images/pc_new/slide/img0106.png"
                class="slide_img06"
              />
              <img
                src="~@/assets/images/pc_new/slide/img0107.png"
                class="slide_img07"
              />
              <img
                src="~@/assets/images/pc_new/slide/img0108.png"
                class="slide_img08"
              />
              <img
                src="~@/assets/images/pc_new/slide/img0109.png"
                class="slide_img09"
              />
            </div>
          </div>
          <div class="items item02">
            <div class="slide_txtarea">
              <p class="slide_txt01">똑똑한 주식상세</p>
              <p class="slide_txt02">
                AI가 한 문장으로 요약해드려요.<br />AI와 전문가들이 꼼꼼하게
                알려드려요.
              </p>
            </div>
            <div class="slide_imgarea">
              <img
                src="~@/assets/images/pc_new/slide/img0201.png"
                class="slide_img01"
              />
              <img
                src="~@/assets/images/pc_new/slide/img0202.png"
                class="slide_img02"
              />
              <img
                src="~@/assets/images/pc_new/slide/img0203.png"
                class="slide_img03"
              />
              <img
                src="~@/assets/images/pc_new/slide/img0204.png"
                class="slide_img04"
              />
              <img
                src="~@/assets/images/pc_new/slide/img0205.png"
                class="slide_img05"
              />
              <img
                src="~@/assets/images/pc_new/slide/img0206.png"
                class="slide_img06"
              />
              <img
                src="~@/assets/images/pc_new/slide/img0207.png"
                class="slide_img07"
              />
            </div>
          </div>
          <div class="items item03">
            <div class="slide_txtarea">
              <p class="slide_txt01">홈</p>
              <p class="slide_txt02">
                쓱 - 밀어서<br />내 보유주식보고, 관심주식보고 <br />금융
                트랜드도 발견하고 <br />핫한 랭킹 확인까지
              </p>
            </div>
            <div class="slide_imgarea">
              <img
                src="~@/assets/images/pc_new/slide/img0301.png"
                class="slide_img01"
              />
              <img
                src="~@/assets/images/pc_new/slide/img0302.png"
                class="slide_img02"
              />
              <img
                src="~@/assets/images/pc_new/slide/img0303.png"
                class="slide_img03"
              />
              <img
                src="~@/assets/images/pc_new/slide/img0304.png"
                class="slide_img04"
              />
              <img
                src="~@/assets/images/pc_new/slide/img0305.png"
                class="slide_img05"
              />
              <img
                src="~@/assets/images/pc_new/slide/img0306.png"
                class="slide_img06"
              />
              <img
                src="~@/assets/images/pc_new/slide/img0307.png"
                class="slide_img07"
              />
              <img
                src="~@/assets/images/pc_new/slide/img0308.png"
                class="slide_img08"
              />
              <img
                src="~@/assets/images/pc_new/slide/img0309.png"
                class="slide_img09"
              />
            </div>
          </div>
          <div class="items item04">
            <div class="slide_txtarea">
              <p class="slide_txt01">자산</p>
              <p class="slide_txt02">
                투자 지갑 자산에서 내 투자 현황과 <br />투자 진행상황을
                한눈에<br />볼 수 있어요.
              </p>
            </div>
            <div class="slide_imgarea">
              <img
                src="~@/assets/images/pc_new/slide/img0401.png"
                class="slide_img01"
              />
              <img
                src="~@/assets/images/pc_new/slide/img0402.png"
                class="slide_img02"
              />
              <img
                src="~@/assets/images/pc_new/slide/img0403.png"
                class="slide_img03"
              />
              <img
                src="~@/assets/images/pc_new/slide/img0404.png"
                class="slide_img04"
              />
              <img
                src="~@/assets/images/pc_new/slide/img0405.png"
                class="slide_img05"
              />
            </div>
          </div>
          <div class="items item05">
            <div class="slide_txtarea">
              <p class="slide_txt01">신용/대출</p>
              <p class="slide_txt02">
                투자금이 필요할때 신용/대출도<br />미니스탁에서 쉽고 빠르게<br />사용하세요.
              </p>
              <p class="slide_txt03">
                *신용/대출은 초고위험 상품이며 투자원금 초과 손실이 발생할 수
                있으니,<br />주요 안내사항을 충분히 숙지하신 후 신청 및
                거래하시기 바랍니다.
              </p>
            </div>
            <div class="slide_imgarea">
              <img
                src="~@/assets/images/pc_new/slide/img0501.png"
                class="slide_img01"
              />
              <img
                src="~@/assets/images/pc_new/slide/img0502.png"
                class="slide_img02"
              />
              <img
                src="~@/assets/images/pc_new/slide/img0503.png"
                class="slide_img03"
              />
            </div>
          </div>
        </div>
      </section>

      <!-- 쉽게 다 되는 투자 플랫폼  -->
      <SectionPlatform />
      
      <!-- Careers -->
      <section class="section_career">
        <div class="inner">
          <h2>
            <img
              src="~@/assets/images/pc_new/img_career_tit.svg"
              class="career_tit"
              alt="Careers"
            />
          </h2>
        </div>
        <div class="career_area">
          <div class="career_container">
            <div class="career_item">
              <img
                src="~@/assets/images/pc_new/career/idcard1.png"
                class="career_img"
                alt="사원증 이미지"
              />
            </div>
            <div class="career_item">
              <img
                src="~@/assets/images/pc_new/career/idcard2.png"
                class="career_img"
                alt="사원증 이미지"
              />
            </div>
            <div class="career_item">
              <img
                src="~@/assets/images/pc_new/career/idcard3.png"
                class="career_img"
                alt="사원증 이미지"
              />
            </div>
            <div class="career_item">
              <img
                src="~@/assets/images/pc_new/career/idcard4.png"
                class="career_img"
                alt="사원증 이미지"
              />
            </div>
          </div>
          <p class="career_txt">
            열정, 도전, 전문역량을 <br />갖춘 변화주도형인재를 모십니다.
          </p>
          <a
            href="https://recruit.truefriend.com/announcementList"
            target="_blank"
          >
            <button type="button" class="btn_career">
              <span>채용공고 보기</span>
            </button>
          </a>
        </div>
      </section>

      <!-- 이용약관 -->
      <section class="section_term">
        <div class="inner">
          <h2>
            <img
              src="~@/assets/images/pc_new/img_term_tit.svg"
              class="term_tit"
              alt="이용약관"
            />
          </h2>
          <ul class="term_list">
            <li
              v-for="(item, index) in termsList.filter(
                (x, index) => index < 10 * count
              )"
              v-bind:key="index"
            >
              <p class="btn_term_txt" @click="pdfUrl(item.pdf, item.type)">
                {{ item.title }}
              </p>
              <button
                type="button"
                class="btn_term_down"
                @click="pdfUrl(item.pdf, item.type)"
              >
                <svg
                  width="23"
                  height="20"
                  viewBox="0 0 23 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M22 14.6364V18.4866C22 18.7702 21.7388 19 21.4167 19H1.58333C1.26117 19 1 18.7702 1 18.4866V14.6364"
                    stroke="#333333"
                    stroke-width="2"
                    stroke-linecap="round"
                  />
                  <path
                    d="M11.5 1V13"
                    stroke="#333333"
                    stroke-width="2"
                    stroke-linecap="round"
                  />
                  <path
                    d="M16.97 8.40968C16.97 8.40968 11.4074 13.7114 11.4074 13.7114C11.4074 13.7114 9.37687 11.6233 6.03006 8.21532"
                    stroke="#333333"
                    stroke-width="2"
                    stroke-linecap="round"
                  />
                </svg>
                <span class="blind">다운로드 버튼</span>
              </button>
            </li>
          </ul>
          <button
            type="button"
            class="btn_term_more"
            @click="paging()"
            v-if="count < 3"
          >
            <span
              >더보기 ({{ 10 * count > 20 ? 24 : 10 * count }}/{{
                termsList.length
              }})</span
            >
            <svg
              width="24"
              height="10"
              viewBox="0 0 16 10"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M1 1L8 8L15 1" stroke="#555555" stroke-width="2" />
            </svg>
          </button>
        </div>
      </section>
      
      <!-- 투자 유의사항 -->
      <SectionToggle />
    </div>

    <!-- 스크롤 탑 버튼 -->
    <button type="button" class="btn_top" @click="scrollTop()" v-if="btnTop">
      <svg
        width="80"
        height="80"
        viewBox="0 0 80 80"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="40" cy="40" r="40" fill="black" />
        <path
          d="M51.231 36.0945L39.3052 17.2727L28.1819 38.2211L39.7065 31.5448V63.6363"
          stroke="white"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
      <span class="blind">위로가기</span>
    </button>
  </div> 
</template>
<script>
//import Animation from "../plugins/animation";
import SectionPlatform from "@/components/pc/SectionPlatform";
import SectionToggle from "@/components/SectionToggle";
//import Fullpage from "../utils/fullpage";
export default {
  components: {
    SectionPlatform,
    SectionToggle,
  },
  data() {
    return {
      count: 1,
      termsList,
      downVisible: false,
      hederShow: true,
      slideShow: "00",
      pc1Ani: null,
      secondShow: false,
      btnTop: false,
    };
  },
  mounted() {
    document.body.style.overflow = "auto";
    window.addEventListener("scroll", () => {
      let scrollLocation = document.documentElement.scrollTop; // 현재 스크롤바 위치

      if (
        (scrollLocation > 1500 && scrollLocation < 2300) ||
        (scrollLocation > 2900 && scrollLocation < 3900) ||
        (scrollLocation > 4500 && scrollLocation < 5500) ||
        (scrollLocation > 6100 && scrollLocation < 7100) ||
        (scrollLocation > 7700 && scrollLocation < 8700)
      ) {
        this.secondShow = true;
      } else {
        this.secondShow = false;
      }

      if (scrollLocation < 900) {
        this.slideShow = "00";
      } else if (scrollLocation > 900 && scrollLocation < 2300) {
        this.slideShow = "01";
      } else if (scrollLocation > 2300 && scrollLocation < 3900) {
        this.slideShow = "02";
      } else if (scrollLocation > 3900 && scrollLocation < 5500) {
        this.slideShow = "03";
      } else if (scrollLocation > 5500 && scrollLocation < 7100) {
        this.slideShow = "04";
      } else if (scrollLocation > 7100 && scrollLocation < 8700) {
        this.slideShow = "05";
      }

      if (
        document.querySelector(".section_main").clientHeight +
          document.querySelector(".section_slide").clientHeight +
          document.querySelector(".section_platform").clientHeight +
          document.querySelector(".section_career").clientHeight -
          300 <
        scrollLocation
      ) {
        this.btnTop = true;
      } else {
        this.btnTop = false;
      }

      if (scrollLocation > 1000 && scrollLocation < 9000) {
        this.hederShow = false;
      } else {
        this.hederShow = true;
      }
    });
  },
  methods: {
    // 특정 슬라이드로 이동
    goSlide(requestIdx) {
      if (requestIdx === 1) {
        //About
        window.scrollTo({
          top: 1100,
          behavior: "smooth",
        });
      } else if (requestIdx === 2) {
        //Career
        const terms = document.querySelector(`.section_career`);
        terms.scrollIntoView({ behavior: "smooth" });
      } else if (requestIdx === 3) {
        //이용약관
        const terms = document.querySelector(`.section_term`);
        terms.scrollIntoView({ behavior: "smooth" });
      }
      this.downVisible = false;
    },
    downClick() {
      (this.downVisible = !this.downVisible),
        document.querySelector(".appdown").classList.toggle("open");
    },
    scrollTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
      this.downVisible = false;
    },
    pdfUrl(seqNo, pdfStatus) {
      let url = `${window.location.protocol}//${window.location.host}/public/terms/service/${seqNo}.pdf`;
      if (pdfStatus) {
        if (pdfStatus === "credit") {
          url = `${window.location.protocol}//${window.location.host}/public/terms/credit/${seqNo}.pdf`;
        }
        if (pdfStatus === "secured") {
          url = `${window.location.protocol}//${window.location.host}/public/terms/secured/${seqNo}.pdf`;
        }
      }
      location.href = url;
    },
    paging() {
      this.count = this.count + 1;
    },
  },
};
const termsList = [
  {
    num: "29",
    title: "해외 ETP 거래에 관한 위험고지",
    pdf: "29", // same oversea_etp_terms.pdf
  },
  {
    num: "28",
    title: "개인(신용)정보 수집·이용 동의서(고객편의서비스 제공용)",
    pdf: "28",
  },
  {
    num: "24",
    title: "개인(신용)정보 수집·이용·제공 동의서(해외상품용)",
    pdf: "23",
  },
  {
    num: "23",
    title:
      "개인(신용)정보 수집·이용·제공·조회 동의서(신용공여/파생/미수거래용)",
    pdf: "22",
  },

  {
    num: "22",
    title: "개인(신용)정보 수집·이용동의서(금융거래설정용)",
    pdf: "20",
  },
  {
    num: "21",
    title: "주식거래설명서",
    pdf: "21",
  },
  {
    num: "19",
    title: "미수동결제도 안내",
    pdf: "19",
  },
  {
    num: "18",
    title: "온라인 거래 장애 발생시 보상기준 및 절차",
    pdf: "18",
  },
  {
    num: "17",
    title: "고객정보 취급방침",
    pdf: "17",
  },
  {
    num: "16",
    title: "비상시 주문안내",
    pdf: "16",
  },
  {
    num: "15",
    title: "예금보험관계 설명서",
    pdf: "15",
  },
  {
    num: "14",
    title: "불법 목적 차명거래 금지 및 접근매체 양도 불법성 안내",
    pdf: "14",
  },
  {
    num: "13",
    title: "QI투자제한동의서",
    pdf: "13",
  },
  {
    num: "11",
    title: "외화증권 거래설명서",
    pdf: "11",
  },
  {
    num: "10",
    title: "미니스탁서비스 설명서",
    pdf: "10",
  },
  {
    num: "9",
    title: "외화증권매매거래계좌설정약관",
    pdf: "09",
  },
  {
    num: "8",
    title: "이체거래이용에관한약관",
    pdf: "08",
  },
  {
    num: "7",
    title: "수익증권저축약관",
    pdf: "07",
  },
  {
    num: "6",
    title: "매매거래계좌설정약관",
    pdf: "06",
  },
  {
    num: "5",
    title: "정보제공서비스약관",
    pdf: "05",
  },
  {
    num: "4",
    title: "증권거래기본약관",
    pdf: "04",
  },
  {
    num: "3",
    title: "전자금융거래이용에 관한 세부약관",
    pdf: "03",
  },
  {
    num: "2",
    title: "전자금융거래이용에 관한 기본약관",
    pdf: "02",
  },
  {
    num: "1",
    title: "일중매매거래/시스템매매 위험고지",
    pdf: "01",
  },
  {
    num: "01",
    title: "신용거래약관",
    pdf: "1",
    type: "credit",
  },
  {
    num: "02",
    title: "신용거래(융자,대주) 거래설명서",
    pdf: "2",
    type: "credit",
  },
  {
    num: "03",
    title: "증권 종합대출 약관",
    pdf: "1",
    type: "secured",
  },
  {
    num: "04",
    title: "증권종합대출 거래설명서",
    pdf: "2",
    type: "secured",
  },
];
</script>
